<template>
    <div class="sidebar">
        <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" background-color="#1395DB"
            text-color="#ffffff" active-text-color="#ffffff" unique-opened>
            <template v-for="item in items">
                <template v-if="item.subs">
                    <el-submenu :index="item.index" @click.native.prevent="handleSelectMenu(item.index)" :key="item.id">
                        <template slot="title">
                            <i :class="item.icon"></i>
                            <span slot="title">{{ item.title }}</span>
                        </template>
                        <template v-for="subItem in item.subs">
                            <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.id"
                                @click.native.stop="handleSelectMenu(subItem.index, $event.target.tagName)">
                                <template slot="title">
                                    <i :class="subItem.icon" style="margin-left: -10px;font-size: 16px"></i>
                                    {{ subItem.title }}
                                </template>
                                <el-menu-item v-for="(threeItem, i) in subItem.subs" :key="i" :index="threeItem.index"
                                    @click.native.stop="handleSelectMenu(threeItem.index)">
                                    <template>
                                        <i :class="threeItem.icon" style="margin-left: -18px;font-size: 14px"></i>
                                        <span slot="title" style="margin-left: -5px;font-size: 14px">{{ threeItem.title
                                            }}</span>
                                    </template>
                                </el-menu-item>
                            </el-submenu>
                            <el-menu-item v-else :index="subItem.index" :key="subItem.index"
                                @click.native.stop="handleSelectMenu(subItem.index)">
                                <template>
                                    <i :class="subItem.icon" style="margin-left: -10px;font-size: 16px"></i>
                                    <span slot="title">{{ subItem.title }}</span>
                                </template>
                            </el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.index" :key="item.index"
                        @click.native.prevent="handleSelectMenu(item.index)">
                        <i :class="item.icon"></i>
                        <span slot="title">{{ item.title }}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
import bus from "@/vuex/eventBus";
import * as menuUtils from "@/utils/menuUtil.js";
export default {
    data() {
        return {
            collapse: false,
            onRoutes: "SystemMain",
            groupType: "1",
            groupId: "",
            roleCode: "",
            items: [],
        };
    },
    methods: {
        showItemByType() {
            // roleCode staff volunteer; 
            // groupType: 1普通机构 2. 简易机构 3.社区 4.居家站点 5.吉年 6.幸福食堂 8.智慧社区 7.服务商
            if (this.roleCode == 'staff' || this.roleCode == 'volunteer') {
                this.items = [];
                this.$router.go(-1);
            } else if (this.groupType == null) {
                this.showNormalAdmin();
            } else if (this.groupType == "5") {
                this.showJn();
            } else if (this.groupType == "6") {
                this.showShiTang();
            } else if (this.groupType == "7") {
                this.showMerchanel();
            }else if (this.groupType == "8") {
                this.items = menuUtils.intelligentCommunity;
            } else if (this.groupType == "3" || this.groupType == "4") {
                this.showShequ();
            } else if (this.groupId == '1034') {
                if (this.roleCode == 'home' || this.roleCode == 'admin') {
                    this.showDongXihuAdmin();
                } else if (this.roleCode == 'serviceMinister' || this.roleCode == 'medicalMinister') {
                    this.showServer();
                } else if (this.roleCode == 'cashier' || this.roleCode == 'charge') {
                    this.showCharge();
                } else if (this.roleCode == 'evaluate' || this.roleCode == 'receptionist' || this.roleCode == 'receptionMinister') {
                    this.showJiedai();
                } else if (this.roleCode == 'nursing') {
                    this.showNurse();
                } else if (this.roleCode == 'houqing' || this.roleCode == 'market') {
                    this.showHouqing();
                }
            } else if (this.groupId == '1655' || this.groupId == '1663' || this.groupId == '1016') {
                this.showHengyxAdmin();
            } else if (this.groupId >1100 && this.groupId < 1500) {
                this.items = menuUtils.xsgroupMenu;
            } else if (this.groupId  == 1680) {
                this.items = menuUtils.xsgroupMenu;
            } else {
                if (this.roleCode == 'home' || this.roleCode == 'admin') {            
                    this.showNormalAdmin();
                } else if (this.roleCode == 'serviceMinister' || this.roleCode == 'medicalMinister') {
                    this.showServer();
                } else if (this.roleCode == 'cashier' || this.roleCode == 'charge') {
                    this.showCharge();
                } else if (this.roleCode == 'evaluate' || this.roleCode == 'receptionist' || this.roleCode == 'receptionMinister') {
                    this.showJiedai();
                } else if (this.roleCode == 'nursing') {
                    this.showNurse();
                } else if (this.roleCode == 'houqing' || this.roleCode == 'market') {
                    this.showHouqing();
                }
            }
        },
        showHengyxAdmin() {
            this.items = menuUtils.deviceGroupMenu;
        },
        showNormalAdmin() {
            this.items = menuUtils.groupMenu;
        },
        showMerchanel() {
            this.items = menuUtils.merchanalList;
        },
        showShiTang() {
            this.items = menuUtils.canteenList;
        },
        showShequ() {
            this.items = menuUtils.communityList;
        },
        showJn() {
            this.items = menuUtils.sampleGroup;
        },
        showDongXihuAdmin() {
            this.items = menuUtils.dxhAdmin;
        },
        showServer() {
            //服务部长
            this.items = menuUtils.groupServer;
        },
        showHouqing() {
            //后勤部门
            this.items = menuUtils.groupLogistics;
        },
        showNurse() {
            //护理员 -班组长
            this.items = menuUtils.groupNurse;
        },
        showJiedai() {
            //接待部
            this.items = menuUtils.groupReception;
        },
        showCharge() {
            //收费部
            this.items = menuUtils.groupCharge;
        },
        handleSelectMenu(item) {
            if (this.$route.path != ("/" + item)) {
                bus.$emit("homePage", {
                    type: "jump",
                    path: ("/" + item)
                });
            }
        }
    },
    created() {
        this.groupType = sessionStorage.getItem("groupType");
        this.groupId = sessionStorage.getItem("groupId");
        this.roleCode = sessionStorage.getItem("roleCode");

        bus.$on('collapse', msg => {
            this.collapse = msg;
            bus.$emit('collapse-content', msg);
        });
        let outjumpFlag = sessionStorage.getItem("outjump");
        if (outjumpFlag && outjumpFlag == 'true') {
            setTimeout(() => {
                this.groupType = sessionStorage.getItem("groupType");
                this.roleCode = sessionStorage.getItem("roleCode");
                this.groupId = sessionStorage.getItem("groupId");
                this.showItemByType();
            }, 2200)
        } else {
            this.showItemByType();
        }
    }
};
</script>

<style scoped>
.sidebar {
    display: block;
    position: absolute;
    left: 0;
    background-color: rgb(19, 149, 219);
    top: 64px;
    bottom: 0;
    overflow-y: scroll;

}

.sidebar-el-menu {
    overflow-x: hidden;
}

.sidebar-el-menu::-webkit-scrollbar {
    width: 0;
    /* 隐藏滚动条 */
}

.sidebar-el-menu ::v-deep .el-submenu__icon-arrow {
    color: #ffffff;
}

.el-submenu__title i {
    color: #ffffff;
}

.el-menu-item i {
    color: #ffffff;
}

.el-submenu__icon-arrow::before {
    color: #ffffff !important;
}

.sidebar::-webkit-scrollbar {
    width: 0;
}

.sidebar-el-menu ::v-deep .el-menu-item i {
    color: #ffffff;
}

.sidebar-el-menu:not(.el-menu--collapse) {
    width: 180px;
}

.sidebar>ul {
    height: 100%;
}
</style>
